import Marquee from "react-fast-marquee";

const items = [
  "Vada Pav",
  "Kanda Poha",
  "Rava Upma",
  "Sooji Shira",
  "Cutting Chai",
  "Freshly Made",
  "Under 5 Minutes",
  "Genuine Ingredients",
];

export const MarqueeStrip = () => {
  return (
    <div
      data-testid="marquee-strip"
      className="bg-[#F59E0B] py-6 overflow-hidden border-y border-black/10"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-[#141110] text-4xl sm:text-5xl lg:text-6xl px-8 tracking-tight">
              {it}
            </span>
            <span className="text-[#E04F33] text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
